<template>
  <BreadCrumb class="hidden sm:block" />
  <AboutPage v-if="entry?.typeHandle === 'aboutPage'" v-bind="{ entry }" />
  <AboutTeamPage v-else-if="entry?.typeHandle === 'aboutTeam'" v-bind="{ entry }" />
</template>

<script>
import gql from 'graphql-tag';
import { stripLocale } from '@/utils/i18n';
import { SeomaticFragment, EntryPageFragment } from '@/mixins/entryPage';
import AboutTeamPage, { AboutTeamPageFragment } from '@/components/about/AboutTeamPage';
import AboutPage, { AboutPageFragment } from '@/components/about/AboutPage';
import { useEntryPage } from '@/composables/useEntryPage';
import BreadCrumb from '@/components/layout/BreadCrumb';

// query for AboutPage and AboutTeamPage
export const AboutIndexQuery = gql`
  query AboutIndexQuery($site: String!, $uri: String!) {
    entry(section: "about", site: [$site], uri: [$uri]) {
      typeHandle
      ...EntryPageFragment
      ...AboutTeamPageFragment
      ...AboutPageFragment
    }

    seomatic(site: $site, uri: $uri, asArray: true) {
      ...SeomaticFragment
    }
  }

  ${EntryPageFragment}
  ${SeomaticFragment}
  ${AboutTeamPageFragment}
  ${AboutPageFragment}
`;

export default defineNuxtComponent({
  name: 'AboutSlug',

  components: { AboutTeamPage, AboutPage, BreadCrumb },

  async asyncData() {
    const { $craftRequest } = useNuxtApp();
    const { locale } = useNuxtApp().$i18n;
    const route = useRoute();
    const uri = stripLocale(route.path, locale.value);
    const variables = { site: locale.value, uri };

    try {
      const { entry, seomatic } = await $craftRequest(AboutIndexQuery, variables);

      return { entry, seomatic };
    } catch (error) {
      console.error(error);
    }
  },

  data() {
    return { entryPage: null };
  },

  created() {
    this.entryPage = useEntryPage(this.entry, this.seomatic);
  },
});
</script>
